var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { FIRE_WORKER_OPTIONS } from '@shared/constants/fireDamageConstants';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
const claim = namespace('claim');
const qualification = namespace('qualification');
const contract = namespace('contract');
let FireWhoMakesWorksQuestion = class FireWhoMakesWorksQuestion extends QuestionComponent {
    updateClaim(fireWhoMakesWorks) {
        this.updateAndSaveFireDamageQualification({
            qualificationPayload: {
                fireWhoMakesWorks,
            },
            step: this.step,
        });
    }
    get answer() {
        if (!this.fireDamageQualification.fireWhoMakesWorks) {
            return null;
        }
        return FIRE_WORKER_OPTIONS[this.fireDamageQualification.fireWhoMakesWorks]
            ? this.$tc(FIRE_WORKER_OPTIONS[this.fireDamageQualification.fireWhoMakesWorks].answerTradKey, 0)
            : null;
    }
    get fireWhoMakesWorksOptions() {
        return Object.values(FIRE_WORKER_OPTIONS);
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], FireWhoMakesWorksQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], FireWhoMakesWorksQuestion.prototype, "fireDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], FireWhoMakesWorksQuestion.prototype, "updateAndSaveFireDamageQualification", void 0);
__decorate([
    contract.State('selectedContract')
], FireWhoMakesWorksQuestion.prototype, "selectedContract", void 0);
FireWhoMakesWorksQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], FireWhoMakesWorksQuestion);
export default FireWhoMakesWorksQuestion;
